//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSecondaryProcessApprove } from '@/api/MES/produceManagement.js';
export default {
  name: 'InspectionResult',
  components: {},
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  data: function data() {
    return {
      data: [],
      loading: false
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    handleChangeList: function handleChangeList() {
      var _this = this;
      this.loading = true;
      getSecondaryProcessApprove(this.fieldData['jumpUrl'], this.rowData['id']).then(function (res) {
        if (res.code === 200) {
          _this.data = res.data;
          _this.loading = false;
        }
      });
    }
  }
};